import { render } from "./FillableBullet.vue?vue&type=template&id=a97e5c58&ts=true"
import script from "./FillableBullet.vue?vue&type=script&lang=ts"
export * from "./FillableBullet.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__